var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSimple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12C0.500001 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12C0.500001 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_145)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_145",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 13H13V43H43V13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7498 32.2119V34.9494C41.7498 37.9994 39.5248 40.8744 36.4998 41.7119C36.2873 41.7619 36.0623 41.7619 35.8623 41.7119C34.3873 41.3119 33.0873 40.4119 32.1748 39.2494C31.1873 38.0244 30.6123 36.5119 30.6123 34.9494V32.2119C30.6123 31.6869 30.9998 31.1119 31.4748 30.9119L34.9498 29.4869C35.7373 29.1744 36.6123 29.1744 37.3998 29.4869L38.6498 29.9994L40.8873 30.9119C41.3623 31.1119 41.7498 31.6869 41.7498 32.2119Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1871 26.7616L38.9621 28.0991L38.0871 27.7491C36.8496 27.2491 35.4996 27.2491 34.2371 27.7491L30.7496 29.1866C29.5621 29.6866 28.7371 30.9241 28.7371 32.2116V34.9491C28.7371 36.4366 29.1496 37.9241 29.9121 39.2491H20.7246C19.0121 39.2491 17.3996 37.8866 17.1121 36.1991L15.5371 26.7616C15.3371 25.5991 15.9246 24.0366 16.8496 23.2991L25.0746 16.7241C26.3371 15.7116 28.3871 15.7116 29.6496 16.7366L37.8746 23.2991C38.7871 24.0366 39.3871 25.5991 39.1871 26.7616Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_145",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_145",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 48.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimple);
export default __webpack_public_path__ + "static/media/icon-simple.8f332a2a1d41f48606aee44b13cb03d3.svg";
export { ForwardRef as ReactComponent };